const texts = {
  es: {
    loginTitle: "Inicio de sesión en Knowee",
    emailLabel: "Correo electrónico",
    passwordLabel: "Contraseña",
    loginButton: "Iniciar sesión",
    dividerText: "o",
    ssoSubtitle: "Acceso Rápido",
    ssoBody: "Inicia sesión automáticamente usando tu correo de Outlook",
    noAccount: "¿No tienes cuenta?",
    createAccountMessage: "Para usar Knowee Signatures, necesitas una cuenta en Knowee. Si aún no tienes una, ",
    createHere: "Crea una aquí",
    createAccountMessage2: "y comienza a mejorar tu red profesional hoy mismo.",
    trySso: "Acceder Automáticamente",
    loggingIn: "Iniciando sesión...",
    ssoLoggingIn: "Iniciando sesión automáticamente",
    accessTokenObtained: "Token de acceso obtenido",
    popupLoggingIn: "Iniciando sesión mediante popup...",
    ssoFailed: "No se pudo iniciar sesión mediante SSO",
    gettingSignatures: "Obteniendo firmas...",
    signaturesObtained: "Firmas obtenidas",
    startButton: "Comenzar",
    logout: "Cerrar sesión",
    moreOptions: "Más opciones",
    lightMode: "Modo claro",
    darkMode: "Modo oscuro",
    enableAddin: "Habilitar complemento",
    disableAddin: "Deshabilitar complemento",
    errorSSOmessage: "Error al iniciar sesión automáticamente",
    loginError: "Error de autenticación",
    firstRunPrimaryText1: "Inserción Automática",
    firstRunSecondaryText1:
      "Tu firma de Knowee con tu tarjeta de visita digital se inserta automáticamente en tus correos",
    firstRunPrimaryText2: "Siempre Actualizada",
    firstRunSecondaryText2: "El diseño de tu firma se actualiza automáticamente cuando se modifica en Knowee",
    firstRunPrimaryText3: "Mejora tu Red Profesional",
    firstRunSecondaryText3: "Facilita a tus contactos guardar tu información actualizada con solo un clic",
    welcomeMessage: "Bienvenido a Knowee Signatures.",
    noSignatures: "No se encontraron firmas",
    selectedSignature: "Firma seleccionada",
    selectSignature: "Seleccionar",
  },
  en: {
    loginTitle: "Login to Knowee",
    emailLabel: "Email",
    passwordLabel: "Password",
    loginButton: "Login",
    dividerText: "or",
    ssoSubtitle: "Quick Access",
    ssoBody: "Login automatically using your Outlook email",
    noAccount: "Don't have an account?",
    createAccountMessage:
      "To use Knowee Signatures, you need an account in Knowee. If you don't have one yet, you can ",
    createHere: "Create one here",
    createAccountMessage2: "and start improving your professional network today.",
    trySso: "Access Automatically",
    loggingIn: "Logging in...",
    ssoLoggingIn: "Logging in automatically",
    accessTokenObtained: "Access token obtained",
    popupLoggingIn: "Logging in using popup...",
    ssoFailed: "Failed to login using SSO",
    gettingSignatures: "Getting signatures...",
    signaturesObtained: "Signatures obtained",
    startButton: "Start",
    logout: "Logout",
    moreOptions: "More options",
    lightMode: "Light mode",
    darkMode: "Dark mode",
    enableAddin: "Enable add-in",
    disableAddin: "Disable add-in",
    errorSSOmessage: "Error logging in automatically",
    loginError: "Authentication error",
    firstRunPrimaryText1: "Automatic Insertion",
    firstRunSecondaryText1:
      "Your Knowee signature with your digital business card is automatically inserted in your emails",
    firstRunPrimaryText2: "Always Updated",
    firstRunSecondaryText2: "Your signature design is automatically updated when modified in Knowee",
    firstRunPrimaryText3: "Improve your Professional Network",
    firstRunSecondaryText3: "Help your contacts save your updated information with just one click",
    welcomeMessage: "Welcome to Knowee Signatures.",
    noSignatures: "No signatures found",
    selectedSignature: "Selected signature",
    selectSignature: "Select",
  },
};

export const getLanguage = () => {
  try {
    const language = typeof Office.context.displayLanguage === "string" ? Office.context.displayLanguage : "en";

    return language.startsWith("es") ? "es" : "en";
  } catch (error) {
    console.error("Error obteniendo el idioma:", error);
    return "en";
  }
};

export const t = (key) => {
  const lang = getLanguage();
  return texts[lang][key] || key;
};
